import { useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Route, Routes } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material'
import { EisenhowerMatrixScreen, PomodoroScreen, TaskScreen } from '@screen'
import { RelatorioScreen } from '@screen/data/data.screen'
import {
  AcademicFeedbackCard,
  AcademicTransparencyBanner,
  ClarityTracker,
  DocumentTitleSync,
  FloatingPomodoroStatus,
  Footer,
  Header,
  Menu,
  PomodoroTimerManager,
} from '@components'
import { initializeStorage } from '@services'
import './App.scss'

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#F29166',
    },
    secondary: {
      main: '#2E7F7B',
    },
    tertiary: {
      main: '#808080',
    },
    background: {
      default: '#F5F5F5',
    },
  },
  components: {
    MuiTextarea: {
      defaultProps: {
        disableFocusRipple: true,
      },
    },
  },
})

function App() {
  useEffect(() => {
    initializeStorage()
  }, [])

  return (
    <>
      <div className="App">
        <HelmetProvider>
          <ThemeProvider theme={defaultTheme}>
            <ClarityTracker />
            <DocumentTitleSync />
            <PomodoroTimerManager />
            <Header />
            <AcademicTransparencyBanner />
            <div className="app__content">
              <section className="home">
                <div className="home__container">
                  <main className="home__main">
                    {' '}
                    <Routes>
                      <Route path="/" element={<PomodoroScreen />} />
                      <Route path="/tarefas" element={<TaskScreen />} />
                      <Route
                        path="/matriz"
                        element={<EisenhowerMatrixScreen />}
                      />
                      <Route path="/relatorio" element={<RelatorioScreen />} />
                    </Routes>
                  </main>
                  <Menu className="home__menu" />
                </div>
              </section>
            </div>
            {/* <FloatingPomodoroStatus /> */}
            <AcademicFeedbackCard />
            <Footer />
          </ThemeProvider>
        </HelmetProvider>
      </div>
    </>
  )
}

export default App
